import SavingWidget from './SavingWidget';

export default SavingWidget;
